import Data from './index';

import { format, formatReact } from 'utils/format';

export function genderString(str, upper) {
  if (!str.length) return str;
  if (str[0] === '[') {
    const pos = str.indexOf(']');
    if (pos >= 0) str = str.slice(pos + 1);
  }
  if (upper !== false) {
    return str[0].toUpperCase() + str.slice(1);
  } else {
    return str;
  }
}

export function genderPair(lhs, rhs, upper) {
  function doPair(lhs, rhs) {
    if (!lhs.length || !rhs.length) return lhs + rhs;
    let key = "ah";
    let m = rhs.match(/\[([a-z]+)\]([^[]+)/);
    if (m) {
      key = m[1];
      rhs = m[2];
    }
    if (lhs[0] !== '[') return lhs + " " + rhs;
    const reg = /\[([a-z]+)\]([^[]+)/g;
    const parts = {};
    while ((m = reg.exec(lhs))) {
      parts[m[1]] = m[2];
    }
    if (!(key in parts)) {
      key = Object.keys(parts)[0];
    }
    return (parts[key] || "") + " " + rhs;
  }
  const str = doPair(lhs, rhs);
  if (upper !== false) {
    return str[0].toUpperCase() + str.slice(1);
  } else {
    return str;
  }
}

export function localeFunction(table, ...names) {
  function translate(str){
    for (let tbl of names) {
      const res = table[tbl] && table[tbl][str];
      if (res) return res;
    }
    return table[str] || str;
  }

  return function(strings, ...args) {
    let src = strings;
    if (Array.isArray(strings)) {
      src = strings.map((str, index) => (index ? `{${index - 1}}` : "") + str.replace(/[{}]/g, "\\$&")).join("");
    }
    src = translate(src);
    if (args.some(x => typeof x === "object")) {
      return formatReact(src, ...args);
    } else {
      return format(src, ...args);
    }
  }
}

export default function Locale(...names) {
  let func = null;
  return function(...args) {
    if (!func) {
      if (!Data.localeTable) {
        throw Error("data is not loaded yet");
      }
      func = localeFunction(Data.localeTable, ...names);
    }
    return func(...args);
  };
}
